import React from "react";

// A failure the reader has to act on. Rose tone, plus the word "error" is
// always in the message the server sent, so colour is never the only signal.
// `role="alert"` is what tells a screen reader the message arrived.
const ErrorNote = ({ children }) => (
  <div role="alert" className="rounded-md border border-tone-rose/30 bg-tone-rose-soft px-3 py-2 text-xs text-tone-rose">
    {children}
  </div>
);

export default ErrorNote;
